/** Execute imperative rules once, with producers before consumers. Shared with the UI. */
import {expressionVariables} from './expressionRuntime';
function orderLogicRules(rules) {
  const list = rules.map((rule) => rule.logic || rule.roi_calculation_logic || rule);
  const actions = (value) => Array.isArray(value) ? value : Object.values(value || {});
  const writers = new Map();
  const reads = [];
  list.forEach((logic, index) => {
    const written = new Set();
    const needed = new Set();
    actions(logic.when).forEach((condition) => {
      if (condition.variable) needed.add(condition.variable);
      if (condition.value_type === "dynamic") needed.add(condition.value);
    });
    actions(logic.then).forEach((step) => {
      if(step.value_type==='expression') expressionVariables(step.value).forEach(ref=>{if(!written.has(ref))needed.add(ref);});
      if (step.value_type === "dynamic" && !written.has(step.value)) needed.add(step.value);
      if (step.action === "calculate") {
        if (step.operator !== "assign" && !written.has(step.variable)) needed.add(step.variable);
        written.add(step.variable);
      }
    });
    written.forEach((variable) => {
      if (!writers.has(variable)) writers.set(variable, []);
      writers.get(variable).push(index);
    });
    reads.push(needed);
  });
  const dependencies = list.map(() => new Set());
  writers.forEach((indices) => indices.forEach((index, position) => {
    if (position) dependencies[index].add(indices[position - 1]);
  }));
  reads.forEach((variables, index) => variables.forEach((variable) => {
    const producers = (writers.get(variable) || []).filter((producer) => producer !== index);
    const preceding = producers.filter((producer) => producer < index);
    const producer = preceding.length ? preceding[preceding.length - 1] : producers[producers.length - 1];
    if (producer !== undefined) dependencies[index].add(producer);
  }));
  const done = new Set();
  const ordered = [];
  while (ordered.length < rules.length) {
    const next = dependencies.findIndex((deps, index) => !done.has(index) && [...deps].every((dep) => done.has(dep)));
    if (next < 0) throw new Error("Calculation rules contain a dependency cycle; combine sequential writes in one rule or remove the cycle.");
    done.add(next);
    ordered.push(rules[next]);
  }
  return ordered;
}

export { orderLogicRules };
